import { c as _c } from "react/compiler-runtime";
import { addDays, format, getDay, getDaysInMonth, startOfMonth } from "date-fns";
import { locale } from "src/lib/locale/date-fns";
;
import DateItem from "src/components/dateselector/DateItem";
import type IDateGroup from "src/components/dateselector/IDateGroup";
import styles from './DateItems.module.css';

//#region [Props]
type DateItemsProps = {
  month?: IDateGroup;
  selectedDate: Date;
  changeDate: (date: Date) => void;
};
//#endregion

//#region [Component]
export default function DateItems(t0) {
  const $ = _c(13);
  const {
    month,
    selectedDate,
    changeDate
  } = t0;
  if (!month) {
    return null;
  }
  const monthLength = getDaysInMonth(month.month);
  const monthFirstDay = getMonthFirstDay(month.month);
  let t1;
  if ($[0] !== changeDate || $[1] !== month || $[2] !== monthFirstDay || $[3] !== monthLength || $[4] !== selectedDate) {
    const items = [];
    let index = 0;
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className={styles.SEmptyItem} key={index++}>M</div>;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    items.push(t2);
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className={styles.SEmptyItem} key={index++}>T</div>;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    items.push(t3);
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className={styles.SEmptyItem} key={index++}>O</div>;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    items.push(t4);
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className={styles.SEmptyItem} key={index++}>T</div>;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    items.push(t5);
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className={styles.SEmptyItem} key={index++}>F</div>;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    items.push(t6);
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div className={styles.SEmptyItem} key={index++}>L</div>;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    items.push(t7);
    let t8;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div className={styles.SEmptyItem} key={index++}>S</div>;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    items.push(t8);
    for (let i = 0; i < monthFirstDay; i++) {
      items.push(<div className={styles.SEmptyItem} key={index++} />);
    }
    let currMonthDay = startOfMonth(month.month);
    for (let i_0 = 0; i_0 < monthLength; i_0++) {
      items.push(<DateItem key={format(currMonthDay, "dd.MM.yyyy", {
        locale
      })} date={currMonthDay} month={month} selectedDate={selectedDate} changeDate={changeDate} />);
      currMonthDay = addDays(currMonthDay, 1);
    }
    t1 = <div className={styles.SCalendar}>{items}</div>;
    $[0] = changeDate;
    $[1] = month;
    $[2] = monthFirstDay;
    $[3] = monthLength;
    $[4] = selectedDate;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
//#endregion

//#region [Other]
function getMonthFirstDay(month: Date) {
  const som = getDay(startOfMonth(month)) - 1;
  return som < 0 ? 6 : som;
}
//#endregion

//#region [Styles]
//#endregion